import React, { useState, useRef,useEffect } from 'react';
import api from './api/client';
import * as XLSX from 'xlsx';
import HeaderLogged from './components/header_logged';
import DataTable from './components/DataTable';
import Container from './components/container';
import Tabs from './components/Tabs';
import TableTittle from './components/TableTittle';
import SearchAndFilter from './components/SearchAndFilter';
import Icons from './components/icons';
import Popup from './components/Popup';
import AddForm from './components/AddForm';
import { API_URL } from './config'

const OrdersPage = () => {
    // Конфигурация фильтров
    const filtersConfig = {
        
    };
    const [filterParams, setFilterParams] = useState(() => {
        const initialFilters = {};
        for (const tab in filtersConfig) {
            filtersConfig[tab].forEach(filter => {
                if (filter.defaultValue) {
                    initialFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        return initialFilters;
    });
    const setDefaultFilters = () => {
        const defaultFilters = {};
        if (Array.isArray(filtersConfig[activeTab])) {
            filtersConfig[activeTab].forEach(filter => {
                if (filter.defaultValue) {
                    defaultFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        setFilterParams(defaultFilters);
    };
    
    // Call this function inside a `useEffect` when the component mounts
    useEffect(() => {
        setDefaultFilters();
    }, []);
    
    const [searchTerm, setSearchTerm] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupFields, setPopupFields] = useState([]);
    const [popupTitle, setPopupTitle] = useState('');
    const [popupSubtitle, setPopupSubtitle] = useState('');
    const [updateKey, setUpdateKey] = useState(0);
    const [activeTab, setActiveTab] = useState('seedsorders'); // Default active tab
    const [data, setData] = useState([]); // Data for the active tab
    const tableRefs = useRef({}); // Reference for table elements

    const keyFieldsConfig = {
        sets: 'SKU',
        brands: 'brandID',
        containers: 'containerID',
        seeds: 'seedsID',
        setscomposition: ['setSKU', 'sbSKU'],
        seedscategory: 'categoryID',
        employees: 'employeeID',
        emplphones: 'employeeID',
        empladdresses: 'employeeID',
        individualpackets: 'SKU',
        sbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
        mbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
        whlocations: 'location',
        seedslocationwh: ['seedsID', 'bagnumid'],
        masterbagsinventory: 'sku',
        smallbagsinventory: 'sku',
        individualpacketsinventory: 'SKU',
        setsInventory: 'SKU',
        wildmicr: 'SKU',
        wildmicrinventory: 'SKU',
        wildmicrproduction: ['SKU', 'emplID', 'prodDate', 'shift'],
        wildmicrmasterbagsinventory: 'sku',
        minitoolsinventory: 'brandID',
        silicagelinventory: 'brandID',
        shipmentsfbamb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentsfbafb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentssbss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentsssmb: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrfba: ['brandID', 'shipmentID','SKU', 'shipmentDate'],
        workperformance: ['employeeID', 'workday', 'shift'],
        materialsuppliers: ['supplierID'],
        seedssuppliers: ['supplierID'],
        smallbagsorder: ['sku',	'orderDate'],
        masterbagsorder: ['sku','orderDate'],
        seedsorders: ['seedsID', 'supplierID', 'orderdate'],
        silicabagsorders: ['brandID', 'orderDate'],
        toolsorders: ['brandID', 'orderDate'],
        wmmasterbagsorder: ['sku','orderDate'],
    };

    const handleSearch = (searchTerm) => {
        setSearchTerm(searchTerm);
    };

    const handleFilter = (params) => {
        setFilterParams(params);
        fetchTabData(`${API_URL}/api/${activeTab}`, params); // Adjust this if needed
    };
    

    const handleEdit = (data, id) => {
        const tableName = activeTab;
        const fields = tabs.find(tab => tab.name === tableName).fields.map(field => ({
            ...field,
            value: data[field.name],
        }));

        const keyFields = keyFieldsConfig[tableName];
        const initialKeyValues = Array.isArray(keyFields) ? keyFields.reduce((acc, key) => {
            acc[key] = data[key];
            return acc;
        }, {}) : { [keyFields]: data[keyFields] };

        setPopupData({ ...data, tableName, id, initialKeyValues });
        setPopupFields(fields);
        setPopupTitle(`Edit ${tableName}`);
        setPopupSubtitle(`Edit ${tableName} details`);
        setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setPopupData(null);
        setPopupFields([]);
    };

    const handlePopupSubmit = async (event) => {
        event.preventDefault();
        console.log('Popup Data:', popupData); // Debugging line

        const updateData = popupFields.reduce((acc, field) => {
            acc[field.name] = field.value;
            return acc;
        }, {});
    
        console.log('Update data:', updateData); // Check if SKU is present here

        try {
            const updateData = popupFields.reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});

            const tableName = popupData.tableName;
            const keyFields = keyFieldsConfig[tableName];
            const isEditMode = !!popupData.id;

            let url;
            let method;
            let currentKeys;

            if (isEditMode) {
                // Обновление
                currentKeys = popupData.initialKeyValues;
                if (Array.isArray(keyFields)) {
                    const id = keyFields.map(key => `${key}=${currentKeys[key]}`).join('&');
                    url = `/api/${tableName}?${id}&currentKeys=${encodeURIComponent(JSON.stringify(currentKeys))}`;
                    method = 'put';
                } else {
                    const id = currentKeys[keyFields];
                    url = `/api/${tableName}/${id}?currentKeys=${encodeURIComponent(JSON.stringify(currentKeys))}`;
                    method = 'put';
                }
            } else {
                // Добавление
                url = `/api/${tableName}`;
                method = 'post';
            }

            console.log(`Sending ${method.toUpperCase()} request to: ${url}`);
            console.log('Update data:', updateData);

            const response = await api({
                method,
                url,
                data: updateData
            });

            console.log('Server response:', response.data);
            handleClosePopup();
            setUpdateKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error(`Error data:`, error);
            if (error.response) {
                console.error('Server responded with:', error.response.data);
            }
        }
    };

    const handleFieldChange = (index, event) => {
        const newFields = [...popupFields];
        newFields[index].value = event.target.value;

        // Update popupData with the new value
        const updatedData = { ...popupData, [newFields[index].name]: event.target.value };
        setPopupFields(newFields);
        setPopupData(updatedData);
    };

    const handleAddClick = () => {
        const fields = tabs.find(tab => tab.name === activeTab).fields.map(field => ({
            ...field,
            value: ''
        }));
        setPopupData({ tableName: activeTab });
        setPopupFields(fields);
        setPopupTitle(`Add New ${activeTab}`);
        setPopupSubtitle(`Add new ${activeTab} details`);
        setIsPopupOpen(true);
    };

    const handleAddSubmit = async (event) => {
        event.preventDefault();
        try {
            const newData = popupFields.reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});

            const tableName = popupData.tableName;

            console.log('handleAddSubmit newData:', newData); // Debugging line
            const response = await api.post(`/api/${tableName}`, newData);
            console.log('Server response:', response.data); // Debugging line
            handleClosePopup();
            setUpdateKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error adding data:', error);
            if (error.response) {
                console.error('Server responded with:', error.response.data);
            }
        }
    };

    const fetchTabData = async (endpoint) => {
        try {
            const response = await api.get(endpoint, {
                params: {
                    page: 1,
                    limit: 100, // Set a large limit to get all data
                    search: searchTerm,
                    ...filterParams
                }
            });
            console.log('Fetched Data:', response.data); // Debugging line
            setData(response.data.items);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }
    };

    const tabs = [
        {
            name: 'seedsorders',
            label: 'Seeds',
            fields: [
                { label: 'Seeds Name', name: 'seedsID', type: 'select', tableName: 'seeds', displayField: 'combinedSeedsName', updateField: 'seedsID'},
                { label: 'Order Date', name: 'orderdate', type: 'date' },
                { label: 'Supplier', name: 'supplierID', type: 'select', tableName: 'seedssuppliers', displayField: 'supplierName', updateField: 'supplierID'},
                { label: 'QTY', name: 'qty', type: 'text' },
                { label: 'Germ. Test Sate', name: 'suptestdate', type: 'date' },
                { label: 'Germ. Rate', name: 'supgermtest', type: 'text' },
                { label: 'Order Status', name: 'orderstatus', type: 'text' },
                { label: 'Shipping Cost', name: 'shipcost', type: 'text' },

            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'Seeds Name', key: 'combinedSeedsName' },
                        { label: 'Order Date', key: 'orderdate' },
                        { label: 'Supplier', key: 'supplierName' },
                        { label: 'QTY', key: 'qty' },
                        { label: 'Germ. Test Sate', key: 'suptestdate' },
                        { label: 'Germ. Rate', key: 'supgermtest' },
                        { label: 'Order Status', key: 'orderstatus' },
                        { label: 'Shipping Cost', key: 'shipcost' },
                    ]}
                    endpoint={`${API_URL}/api/seedsorders`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleEdit(data, `${data.sku}-${data.emplID}-${data.prodDate}-${data.shift}`)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            )
        },
        {
            name: 'smallbagsorder',
            label: 'Small Bags',
            fields: [
                { label: 'Name', name: 'sku', type: 'select', tableName: 'individualpackets', displayField: 'packName', updateField: 'SKU' },
                { label: 'Order Date', name: 'orderDate', type: 'date' },
                { label: 'Supplier', name: 'supplierID', type: 'select', tableName: 'materialsuppliers', displayField: 'supplierName', updateField: 'supplierID' },
                { label: 'QTY', name: 'currentQTY', type: 'text' },
                { label: 'Shipping Cost', name: 'shipcost', type: 'text' },
                { label: 'Status', name: 'orderstatus', type: 'text' },
                { label: 'Est. Delivery Date', name: 'estdeliveryDate', type: 'date' },
                { label: 'Shipping Carrier', name: 'shippingService', type: 'text' },
                { label: 'Tracking Number', name: 'trackNum', type: 'text' },

            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'Name', key: 'packName' },
                        { label: 'Order Date', key: 'orderDate' },
                        { label: 'Supplier', key: 'supplierName' },
                        { label: 'QTY', key: 'currentQTY' },
                        { label: 'Shipping Cost', key: 'shipcost' },
                        { label: 'Status', key: 'orderstatus' },
                        { label: 'Est. Delivery Date', key: 'estdeliveryDate' },
                        { label: 'Shipping Carrier', key: 'shippingService' },
                        { label: 'Tracking Number', key: 'trackNum' },
                    ]}
                    endpoint={`${API_URL}/api/smallbagsorder`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleEdit(data, `${data.sku}-${data.emplID}-${data.prodDate}-${data.shift}`)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            )
        },
        {
            name: 'masterbagsorder',
            label: 'Sets Bags',
            fields: [
                { label: 'Name', name: 'sku', type: 'select', tableName: 'sets', displayField: 'setmane', updateField: 'SKU' },
                { label: 'Order Date', name: 'orderDate', type: 'date' },
                { label: 'Supplier', name: 'supplierID', type: 'select', tableName: 'materialsuppliers', displayField: 'supplierName', updateField: 'supplierID' },
                { label: 'QTY', name: 'QTY', type: 'text' },
                { label: 'Shipping Cost', name: 'shipcost', type: 'text' },
                { label: 'Status', name: 'orderstatus', type: 'text' },
                { label: 'Est. Delivery Date', name: 'estdeliveryDate', type: 'date' },
                { label: 'Shipping Carrier', name: 'shippingService', type: 'text' },
                { label: 'Tracking Number', name: 'trackNum', type: 'text' },

            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'Name', key: 'setmane' },
                        { label: 'Order Date', key: 'orderDate' },
                        { label: 'Supplier', key: 'supplierName' },
                        { label: 'QTY', key: 'currentQTY' },
                        { label: 'Shipping Cost', key: 'shipcost' },
                        { label: 'Status', key: 'orderstatus' },
                        { label: 'Est. Delivery Date', key: 'estdeliveryDate' },
                        { label: 'Shipping Carrier', key: 'shippingService' },
                        { label: 'Tracking Number', key: 'trackNum' },
                    ]}
                    endpoint={`${API_URL}/api/masterbagsorder`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleEdit(data, `${data.sku}-${data.emplID}-${data.prodDate}-${data.shift}`)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            )
        },
        {
            name: 'wmmasterbagsorder',
            label: 'Wildflowers & Microgreens Bags',
            fields: [
                { label: 'Name', name: 'sku', type: 'select', tableName: 'wildmicr', displayField: 'packName', updateField: 'SKU' },
                { label: 'Order Date', name: 'orderDate', type: 'date' },
                { label: 'Supplier', name: 'supplierID', type: 'select', tableName: 'materialsuppliers', displayField: 'supplierName', updateField: 'supplierID' },
                { label: 'QTY', name: 'QTY', type: 'text' },
                { label: 'Shipping Cost', name: 'shipcost', type: 'text' },
                { label: 'Status', name: 'orderstatus', type: 'text' },
                { label: 'Est. Delivery Date', name: 'estdeliveryDate', type: 'date' },
                { label: 'Shipping Carrier', name: 'shippingService', type: 'text' },
                { label: 'Tracking Number', name: 'trackNum', type: 'text' },

            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'Name', key: 'packName' },
                        { label: 'Order Date', key: 'orderDate' },
                        { label: 'Supplier', key: 'supplierName' },
                        { label: 'QTY', key: 'QTY' },
                        { label: 'Shipping Cost', key: 'shipcost' },
                        { label: 'Status', key: 'orderstatus' },
                        { label: 'Est. Delivery Date', key: 'estdeliveryDate' },
                        { label: 'Shipping Carrier', key: 'shippingService' },
                        { label: 'Tracking Number', key: 'trackNum' },
                    ]}
                    endpoint={`${API_URL}/api/wmmasterbagsorder`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleEdit(data, `${data.sku}-${data.emplID}-${data.prodDate}-${data.shift}`)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            )
        },
        {
            name: 'toolsorders',
            label: 'Tools',
            fields: [
                { label: 'Brand', name: 'brandID', type: 'select', tableName: 'brands', displayField: 'brandName', updateField: 'brandID' },
                { label: 'Order Date', name: 'orderDate', type: 'date' },
                { label: 'Supplier', name: 'supplierID', type: 'select', tableName: 'materialsuppliers', displayField: 'supplierName', updateField: 'supplierID' },
                { label: 'QTY', name: 'qty', type: 'text' },
                { label: 'Shipping Cost', name: 'shipCost', type: 'text' },
                { label: 'Status', name: 'orderStatus', type: 'text' },
                { label: 'Est. Delivery Date', name: 'estDelDate', type: 'date' },
                { label: 'Shipping Carrier', name: 'shipService', type: 'text' },
                { label: 'Tracking Number', name: 'trackNum', type: 'text' },

            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'Brand', key: 'brandName' },
                        { label: 'Order Date', key: 'orderDate' },
                        { label: 'Supplier', key: 'supplierName' },
                        { label: 'QTY', key: 'qty' },
                        { label: 'Shipping Cost', key: 'shipCost' },
                        { label: 'Status', key: 'orderStatus' },
                        { label: 'Est. Delivery Date', key: 'estDelDate' },
                        { label: 'Shipping Carrier', key: 'shipService' },
                        { label: 'Tracking Number', key: 'trackNum' },
                    ]}
                    endpoint={`${API_URL}/api/toolsorders`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleEdit(data, `${data.sku}-${data.emplID}-${data.prodDate}-${data.shift}`)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            )
        },
        {
            name: 'silicabagsorders',
            label: 'Silicabags',
            fields: [
                { label: 'Brand', name: 'brandID', type: 'select', tableName: 'brands', displayField: 'brandName', updateField: 'brandID' },
                { label: 'Order Date', name: 'orderDate', type: 'date' },
                { label: 'Supplier', name: 'supplierID', type: 'select', tableName: 'materialsuppliers', displayField: 'supplierName', updateField: 'supplierID' },
                { label: 'QTY', name: 'qty', type: 'text' },
                { label: 'Shipping Cost', name: 'shipCost', type: 'text' },
                { label: 'Status', name: 'orderStatus', type: 'text' },
                { label: 'Est. Delivery Date', name: 'estDelDate', type: 'date' },
                { label: 'Shipping Carrier', name: 'shipService', type: 'text' },
                { label: 'Tracking Number', name: 'trackNum', type: 'text' },

            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'Brand', key: 'brandName' },
                        { label: 'Order Date', key: 'orderDate' },
                        { label: 'Supplier', key: 'supplierName' },
                        { label: 'QTY', key: 'currentQTY' },
                        { label: 'Shipping Cost', key: 'shipCost' },
                        { label: 'Status', key: 'orderStatus' },
                        { label: 'Est. Delivery Date', key: 'estDelDate' },
                        { label: 'Shipping Carrier', key: 'shipService' },
                        { label: 'Tracking Number', key: 'trackNum' },
                    ]}
                    endpoint={`${API_URL}/api/silicabagsorders`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleEdit(data, `${data.sku}-${data.emplID}-${data.prodDate}-${data.shift}`)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            )
        },
        
        
    ];

    return (
        <>
            <Icons />
            <HeaderLogged />
            <Container>
                <TableTittle
                    sectionTitle="Orders"
                    sectionSubtitle="Manage order's details"
                    onAddClick={handleAddClick}
                    activeTab={activeTab}
                    tableRefs={tableRefs}
                />
                <SearchAndFilter
                    placeholder="Search by date, employee name, seeds..."
                    onSearch={handleSearch}
                    filtersConfig={filtersConfig[activeTab] || []}
                />
                <Tabs
                    tabs={tabs}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    tableRefs={tableRefs}
                />
            </Container>
            {popupData && (
                <Popup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    title={popupTitle}
                    subtitle={popupSubtitle}
                    fields={popupFields}
                    onFieldChange={handleFieldChange}
                    onSubmit={handlePopupSubmit}
                />
            )}
        </>
    );
};

export default OrdersPage;
